/** @flow */

import type { UserPermissionsState } from "./types";

export const initialState: UserPermissionsState = {
  requestsInProgress: 0,
  error: null,
  success: null,
  schema: null,
  effectiveUserPermissions: {
    absenceMonitoringDetails: false,
    allowManagerEditEmployeesShiftPattern: false,
    benchmarkingStatistics: false,
    closeAbsences: "",
    employeeAccounts: false,
    excludeAbsencesFromAlerts: false,
    isLocked: false,
    notificationAdmin: "",
    permittedExtension: 1,
    reportAbsences: "",
    selfServiceEnabled: false,
    updateAbsences: "",
    viewRtwForms: false,
  },
  modals: {
    showEmployeeUsersModal: false,
  },
};

export default initialState;
